import { render, staticRenderFns } from "./QLink.vue?vue&type=template&id=053a02a4&"
import script from "./QLink.vue?vue&type=script&lang=js&"
export * from "./QLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports